import styled from "styled-components";
import Button from "../Button";

const ToastBody = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 8px;
  align-items: center;
  min-height: 30px;
`;

const ToastButton = styled(Button)`
  color: rgb(${(props) => props.theme.colors.neutral200});
  background: rgb(${(props) => props.theme.colors.offWhite});
  border: 2px solid rgb(${(props) => props.theme.colors.neutral100});
  border-radius: 4px;
  padding: 2px;
  height: 32px;
  min-width: 84px;

  * {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    letter-spacing: -0.05em;
  }
`;

export { ToastBody, ToastButton };
